import { LeftRight } from "@/components/LeftRight.tsx";
import { WSelect, type WSelectStyleProps, type WSelectValueProps } from "@/components/forms/WSelect.tsx";
import { useConfig } from "@/config.ts";
import { CountryFlag } from "@/modules/location/CountryFlag.tsx";
import { allCountries, type CountryInfo } from "@/modules/location/locationCountry.ts";
import { sortBy } from "remeda";

export interface CountrySelectProps extends WSelectValueProps<CountryInfo, string>, WSelectStyleProps {}

export function CountrySelect(props: CountrySelectProps) {
    const { siteCountry } = useConfig();
    const countries = allCountries();

    return (
        <WSelect
            autoFocusSearch
            defaultValueKey={siteCountry}
            getKey={(item) => (props.valueKey?.length === 3 ? item.code.iso3 : item.code.iso2)}
            items={sortBy(countries, (l) => l.name)}
            aria-label="Country"
            getTextValue={(item) => item.name}
            searchItems
            {...props}
        >
            {({ name, code: { iso3 } }) => <LeftRight icon={<CountryFlag code={iso3} />} title={name} />}
        </WSelect>
    );
}
